@if (showOpacityMenu) {
  <div odxlayout="gap-none" class="opacity-menu flex-column w-100 container">
    <h6 class="odx-title-6" i18n="@@opacity.header">Deckkraft</h6>
    <hr />
    <form odxForm [formGroup]="opacityForm">
      <input
        #opacitySlider
        odxSlider
        type="range"
        formControlName="opacity"
        [step]="1"
        [max]="100"
        [min]="0"
        class="slider"
        (input)="opacityInput.value = opacitySlider.value"
      />
      <div odxLayout="flex" class="opacity-flex">
        <odx-form-field i18n-label="@@opacity.input" label="Deckkraft" class="flex-item">
          <input
            #opacityInput
            type="number"
            formControlName="opacity"
            odxFormFieldControl
            min="0"
            max="100"
            i18n-placeholder="@@opacity.placeholder.input"
            placeholder="Deckkraft"
            (input)="opacitySlider.value = opacityInput.value"
          />
        </odx-form-field>
        <button class="flex-item opacity-button" odxButton (click)="resetOpacity()" variant="primary">
          <odx-icon name="reset" alignleft size="medium"></odx-icon>
          <span i18n="@@opacity.button.resetOpacity">Reset</span>
        </button>
      </div>
    </form>
  </div>
}

<button odxButton (click)="toggleOpacityMenu()">
  <odx-icon name="mode-switch" size="medium"></odx-icon>
</button>
